<script lang="ts">
    import { COUNTRIES } from "@/constants/countryInfo";

    import Image from "@components/Image/Image.svelte";

    export let value: string;
    export let label: string;

    $: country = COUNTRIES?.find((country) => country.code === value);
</script>

<div class="gw-rv-attributes-answers__country">
    <span class="gw-rv-attributes-answers__country-title">
        {country?.value}
    </span>
    <span class="gw-rv-attributes-answers__country-image">
        <Image src={country?.imgSrc || ""} alt={label} objectFit="cover" />
    </span>
</div>

<style lang="postcss">
    .gw-rv-attributes-answers__country {
        display: flex;
        align-items: center;
        gap: 0.5em;

        &-title {
            font-size: 0.875em;
            font-weight: 400;
        }

        &-image {
            width: 25px;
            height: 15px;
        }
    }
</style>
